// extracted by mini-css-extract-plugin
export var container = "authorPhotoNameByline-module--container--f315c";
export var name = "authorPhotoNameByline-module--name--94dc0";
export var photo = "authorPhotoNameByline-module--photo--4dc92";
export var text = "authorPhotoNameByline-module--text--3f379";
export var textLink = "authorPhotoNameByline-module--textLink--e898f";